import { jsx, Fragment } from "react/jsx-runtime";
import { Children } from "react";
import { SpaceMd } from "@nxt-costco-com/forge-design-tokens";
import { CostcoBox } from "../../../../Util/CostcoBox.js";
const HalfBanner = ({
  children
}) => {
  const isSinglehalfBanner = Children.count(children) === 1;
  return /* @__PURE__ */ jsx(Fragment, { children: Children.map(children, (child, index) => {
    return /* @__PURE__ */ jsx(
      CostcoBox,
      {
        sx: {
          display: "flex",
          flex: {
            md: isSinglehalfBanner ? "100%" : `calc(50% - ${SpaceMd})`,
            xs: "100%"
          },
          maxWidth: {
            md: isSinglehalfBanner ? "100%" : `calc(50% - ${SpaceMd})`,
            xs: "100%"
          }
        },
        ...isSinglehalfBanner && {
          "data-layout": "large_half_banner"
        },
        children: child
      },
      index
    );
  }) });
};
export {
  HalfBanner
};
